// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'

import moment from 'moment'
import IdleVue from "idle-vue";

import '../metrics'
import '../registerServiceWorker'

import { consoleBuildInfo } from 'vue-cli-plugin-build-info/plugin'
import { PdfViewerPlugin } from '@syncfusion/ej2-vue-pdfviewer';
import VTooltip from 'v-tooltip';

consoleBuildInfo()

// global variables
Vue.prototype.$apiUrl = 'https://cloud.cft.co.ke/index.php/api/saccodemo_v2/'

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(VTooltip);
Vue.config.productionTip = false;
new Vue({
  render: h => h(App)
});
Vue.use(PdfViewerPlugin);

Vue.use(ColorThemePlugin, {
  // override colors here. #df902a
  primary: '#f6811e',
  secondary: '#2f3097',
  other: '#ffffff',
})

Vue.filter('upText', function (text) {
  return text.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD dddd MMMM')
  }
})

Vue.filter('formatLongDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD MMMM YYYY')
  }
})

Vue.filter('createDate', function (days, months, years) {
    var date = new Date(); 
    date.setDate(date.getDate() + days);
    date.setMonth(date.getMonth() + months);
    date.setFullYear(date.getFullYear() + years);
    return date;    
});

Vue.filter('dateToYMD', function (date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
});


Vue.filter('Currency', function (text) {
  let val =  text.toString();  
  val = val.replace(/,/g,''); 
  val = (val / 1).toFixed(2)
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('DateDiff', function(From, To) {
  var dateFrom = new Date(From);
  var dateTo = new Date(To);
  return dateTo.getMonth() - dateFrom.getMonth() + 
   (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
})


const eventsHub = new Vue();
 
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
     idleTime: 300000, // 5 mins to logout,
  startAtIdle: false
});

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
